import React from "react";
import { Camera, MessageSquare, CheckCircle2 } from "lucide-react";

const STEPS = [
  {
    icon: Camera,
    title: "Snap a photo",
    body: "Point your camera at whatever needs clearing. Add a postcode and a few words. That's the whole listing.",
  },
  {
    icon: MessageSquare,
    title: "Receive quotes",
    body: "Registered waste carriers in your area send fixed prices. No auction stress — just clear quotes.",
  },
  {
    icon: CheckCircle2,
    title: "Choose and done",
    body: "Pick your carrier, confirm the time. They collect, you get a duty-of-care receipt. Job sorted.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="py-20 md:py-28 bg-white"
      data-testid="how-it-works"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-sage-700">
            How it works
          </p>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl font-extrabold text-moss-950 leading-[1.05] text-balance">
            Three steps. Takes just a few minutes.
          </h2>
        </div>

        <ol className="mt-14 grid md:grid-cols-3 gap-8 lg:gap-12">
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <li
                key={step.title}
                className="relative"
                data-testid={`how-step-${i + 1}`}
              >
                <div className="flex items-center gap-4">
                  <span className="font-display text-5xl font-black text-sage-500/25 leading-none">
                    0{i + 1}
                  </span>
                  <div className="w-12 h-12 rounded-2xl bg-sage-100 text-sage-800 flex items-center justify-center">
                    <Icon className="w-6 h-6" strokeWidth={2.25} />
                  </div>
                </div>
                <h3 className="font-display mt-6 text-2xl font-bold text-moss-950 leading-tight">
                  {step.title}
                </h3>
                <p className="mt-3 text-base text-moss-700 leading-relaxed">
                  {step.body}
                </p>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
